import { NamedModelHistory as NamedModelHistoryEntry, NamedModel } from 'api/Exec/types';
import DetailedNamedModel from 'components/Dashboard/Models/NamedModels/DetailedNamedModel/DetailedNamedModel';
import useNamedModelHistory from 'components/Dashboard/Models/NamedModels/NamedModelHistory/useNamedModelHistory';
import useNamedModelHistoryColumns from 'components/Dashboard/Models/NamedModels/NamedModelHistory/useNamedModelHistoryColumns';

import React, { useState } from 'react';
import { Modal, Table, Typography } from 'antd';

interface Props {
  model: NamedModel | null;
}

const NamedModelHistory: React.FC<Props> = ({ model }) => {
  const { namedModelHistory, isLoading } = useNamedModelHistory(model?.id);

  const [ isDetailedModelOpen, setIsDetailedModelOpen ] = useState<NamedModelHistoryEntry | null>(null);
  const openDetailedModel = (model: NamedModelHistoryEntry) => setIsDetailedModelOpen(model);
  const closeDetailedModel = () => setIsDetailedModelOpen(null);

  const { columns } = useNamedModelHistoryColumns(openDetailedModel);

  return (
    <>
      <Table
        rowKey={record => record.id}
        columns={columns}
        dataSource={namedModelHistory}
        pagination={false}
        scroll={{ x: true }}
        loading={isLoading}
      />

      <Modal
        title={<Typography.Title level={4}>Named model history details</Typography.Title>}
        open={!!isDetailedModelOpen}
        footer={null}
        width={1000}
        onCancel={closeDetailedModel}
        destroyOnClose
      >
        <DetailedNamedModel model={isDetailedModelOpen} />
      </Modal>
    </>
  );
};

export default NamedModelHistory;
